import { useState, useEffect } from "react";
import "./assets/css/main.scss";
import { RouterProvider } from "react-router-dom";
import { routerUtility } from "./includes/utilities/router";
import LoadingComponent from "./includes/loading";

function App() {
  const [allPosts, setAllPosts] = useState(null);

  useEffect(() => {
    const url =
      "https://cms.madebyparry.com/api/v2/content?_format=json&type=parry_news";
    const options = {
      method: "GET",
    };
    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        setAllPosts(Object.values(data));
        console.log("got response ->", data);
      })
      .catch((error) => console.log(error));
  }, []);

  if (allPosts === null) {
    return <LoadingComponent/>
  } else {
    return (
      <>
        <RouterProvider router={routerUtility({allPosts})} />
      </>
    );
  }
}

export default App;
